export const isMobileKeyboardOpen = () => {
  const minKeyboardHeight = 300;
  const mobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  return mobileDevice && window.screen.height - minKeyboardHeight > window.visualViewport.height;
};
